<script>
import Vue from 'vue'
import { Restaurants } from '@/api'
import restaurantList from '@/modules/mixins/restaurantList'
import RestaurantCard from '@/components/organism/restaurants/RestaurantCard'
import { mapGetters } from 'vuex'

const restaurants = Vue.observable(new Restaurants())

export default {
    name: 'FeaturedRestaurants',

    components: { RestaurantCard },

    mixins: [restaurantList],

    data() {
        return {
            searchVal: this.$route.query.search || undefined,
            pageTitle: this.$t('labels.popular_restaurants'),
        }
    },

    computed: {
        ...mapGetters({
            orderAsap: 'order/asap',
            orderTime: 'order/time',
        }),
        restaurants: () => restaurants,
    },

    watch: {
        orderAsap() {
            this.restaurants.fetchRestaurants({ featured: true })
        },
        orderTime() {
            this.restaurants.fetchRestaurants({ featured: true })
        },
    },

    methods: {
        getPage(page) {
            this.restaurants.fetchRestaurants({ page: page })
        },
    },

    beforeRouteEnter(to, from, next) {
        restaurants
            .fetchRestaurants({ featured: true })
            .then(() => next())
            .catch(() => next())
    },
}
</script>

<template lang="pug">
.restaurants-page.pt-page.pb-page
    router-link.font-size-m.d-inline-flex.align-items-center(:to="{name:'restaurant-list'}")
        icon.mr-3(icon="fa-solid fa-long-arrow-alt-left")
        | {{$t('restaurant.back_all')}}
    transition(name="fade" mode="out-in")
        .mt-4(v-if="restaurants.length")
            h2.d-flex.align-items-baseline.justify-content-between {{$t('restaurant.featured')}}
                span.text-73.font-size-xs {{$t('restaurant.restaurants', {count: restaurants.total }, restaurants.total)}}
            .row(v-observer="getPage")
                restaurant-card.mb-9(
                    v-for="(restaurant, index) in restaurants" 
                    :key="`${restaurant.id}-${index}`" 
                    :data-page="index && [0 , restaurants.itemsPerPage-1].includes(index%restaurants.itemsPerPage) && !restaurant  ? Math.floor((index/restaurants.itemsPerPage))+1 : undefined"
                    :data-index="index" 
                    :model="restaurant")

</template>
